import React from 'react';

const Download = (props) => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M15 10c.552 0 1 .45 1 1.006v2.51c0 1.196-.619 2.082-1.73 2.437-.098.031-.2.047-.303.047H2.033c-.103 0-.205-.016-.303-.047C.619 15.598 0 14.713 0 13.516v-2.51C0 10.45.448 10 1 10c.553 0 1 .45 1 1.006v2.51c0 .276 0 .493.504.493H13.57c.394 0 .427-.182.43-.425v-2.578c0-.556.448-1.006 1-1.006zM9 0c.552 0 1 .439 1 .98V6h1.996c.647 0 .994.871.565 1.345l-4 4.408c-.299.33-.823.33-1.122 0l-4-4.408C3.01 6.871 3.354 6 4.002 6H6V.98C6 .439 6.448 0 7 0h2z" />
  </svg>
);

export default Download;
